import React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { Container, Row, Col, Button, Collapse } from "react-bootstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { NextSeo } from "next-seo";

const Career = ({ isLoggedIn }) => {
  const [open, setOpen] = React.useState(false);
  const metaImg =
    "https://firebasestorage.googleapis.com/v0/b/vip-bari.appspot.com/o/researchrider-careers.jpeg?alt=media&token=dd3ffe70-1c3b-4ec5-b9a6-a6092c39b53c";

  return (
    <Container className="pt-5 mt-5">
      <NextSeo
        title="Careers | Join with us"
        description="Grow up Being a Researcher | Join with us"
        canonical="https://www.researchrider.com/careers"
        openGraph={{
          url: "https://www.researchrider.com/careers",
          title: "Careers | Join with us",
          description: "Grow up Being a Researcher | Join with us",
          siteName: "Research Rider",
          images: [
            {
              url: `${metaImg}`,
              width: 800,
              height: 600,
              alt: `join researchrider`,
            },
          ],
        }}
      />

      <div className={isLoggedIn ? "" : "pt-5"}>
        <Typography gutterBottom variant="h4" component="div">
          We&apos;re Hiring!
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Make yourself comfortable with Research Rider
        </Typography>

        <Row className="justify-content-center py-3">
          <div className="d-flex align-items-center justify-content-between">
            <Typography gutterBottom variant="h6" component="div">
              Senior Django Developer | Full-time{" "}
              <span className="text-primary">(Open)</span>
            </Typography>
            <Button>
              <a
                className="fw-bold text-white"
                href="mailto: researchriderit@gmail.com"
              >
                Apply Now
              </a>
            </Button>
          </div>
          <Col>
            <Typography
              className="pb-2"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              Research rider is looking to hire a Senior Django Developer in
              Dhaka, Bangladesh having 2 years plus experience as a developer.
            </Typography>

            <Typography gutterBottom variant="subtitle1" component="div">
              The ideal candidate is a self-motivated, multi-tasker, and
              demonstrated team-player. You will be a lead developer responsible
              for the development of new software products and enhancements to
              existing products. You should excel in working with large-scale
              applications and frameworks and have outstanding communication and
              leadership skills.
            </Typography>
          </Col>
        </Row>

        <Row>
          <Typography
            className="pb-2"
            fontWeight={500}
            variant="h6"
            component="div"
          >
            General Information
          </Typography>
          <Col md={2}>
            <Typography
              className="fw-bold"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              Salary :
            </Typography>
          </Col>
          <Col md={8}>
            <Typography
              className="px-3"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              Negotiable
            </Typography>
          </Col>
        </Row>

        <Row>
          <Col md={2}>
            <Typography
              className="fw-bold"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              Working time :
            </Typography>
          </Col>
          <Col md={8}>
            <Typography
              className="px-3"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              9AM - 6PM
            </Typography>
          </Col>
        </Row>

        <Row className="pb-3">
          <Col md={2}>
            <Typography
              className="fw-bold"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              Office Location :
            </Typography>
          </Col>
          <Col md={8}>
            <Typography
              className="px-3"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              Rupnagar, Mirpur 2, Dhaka, Bangladesh
            </Typography>
          </Col>
        </Row>

        <Row className="flex-wrap">
          <Col md={7} xs={12}>
            <Typography
              className="pb-2"
              fontWeight={500}
              variant="h6"
              component="div"
            >
              Responsibilities
            </Typography>

            <List>
              {Responsibilities.map((res, idx) => (
                <ListItem key={idx} className="p-0">
                  <CheckCircleIcon color="primary" sx={{ fontSize: "20px" }} />
                  <ListItemText className="mx-2" primary={res.res} />
                </ListItem>
              ))}
            </List>
          </Col>
          <Col md={5} xs={12}>
            <Typography
              className="pb-2"
              fontWeight={500}
              variant="h6"
              component="div"
            >
              Requirements
            </Typography>

            <List>
              {Requirements.map((req, idx) => (
                <ListItem key={idx} className="p-0">
                  <CheckCircleIcon color="primary" sx={{ fontSize: "20px" }} />
                  <ListItemText className="mx-2" primary={req.req} />
                </ListItem>
              ))}
            </List>

            <Typography
              className="pt-3"
              fontWeight={500}
              variant="h6"
              component="div"
            >
              Benefits
            </Typography>

            <List>
              <ListItem className="p-0">
                <CheckCircleIcon color="primary" sx={{ fontSize: "20px" }} />
                <ListItemText className="mx-2" primary="Yearly salary review" />
              </ListItem>
            </List>
          </Col>
        </Row>
        <Row className="py-3">
          <Typography
            className="pb-2"
            fontWeight={500}
            variant="h6"
            component="div"
          >
            Working days
          </Typography>

          <Typography gutterBottom variant="subtitle1" component="div">
            Weekly: 5 days <br />
            Weekend: Friday, Saturday
          </Typography>
        </Row>
      </div>

      <div>
        <Row className="justify-content-center py-3">
          <Typography gutterBottom variant="h6" component="div">
            Senior Django Developer | Full-time{" "}
            <span className="text-danger">(Close)</span>
          </Typography>
          <Col>
            <Typography
              className="pb-2"
              gutterBottom
              variant="subtitle1"
              component="div"
            >
              Research rider is looking to hire a Senior Django Developer in
              Dhaka, Bangladesh having 2 years plus experience as a developer.
            </Typography>

            <Typography gutterBottom variant="subtitle1" component="div">
              The ideal candidate is a self-motivated, multi-tasker, and
              demonstrated team-player. You will be a lead developer responsible
              for the development of new software products and enhancements to
              existing products. You should excel in working with large-scale
              applications and frameworks and have outstanding communication and
              leadership skills.
            </Typography>
          </Col>
        </Row>

        <Collapse in={open}>
          <div>
            <Row>
              <Typography
                className="pb-2"
                fontWeight={500}
                variant="h6"
                component="div"
              >
                General Information
              </Typography>
              <Col md={2}>
                <Typography
                  className="fw-bold"
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Salary :
                </Typography>
              </Col>
              <Col md={8}>
                <Typography
                  className="px-3"
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Negotiable
                </Typography>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Typography
                  className="fw-bold"
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Working time :
                </Typography>
              </Col>
              <Col md={8}>
                <Typography
                  className="px-3"
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  9AM - 6PM
                </Typography>
              </Col>
            </Row>

            <Row className="pb-3">
              <Col md={2}>
                <Typography
                  className="fw-bold"
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Office Location :
                </Typography>
              </Col>
              <Col md={8}>
                <Typography
                  className="px-3"
                  gutterBottom
                  variant="subtitle1"
                  component="div"
                >
                  Rupnagar, Mirpur 2, Dhaka, Bangladesh
                </Typography>
              </Col>
            </Row>

            <Row className="flex-wrap">
              <Col md={7} xs={12}>
                <Typography
                  className="pb-2"
                  fontWeight={500}
                  variant="h6"
                  component="div"
                >
                  Responsibilities
                </Typography>

                <List>
                  {Responsibilities.map((res, idx) => (
                    <ListItem key={idx} className="p-0">
                      <CheckCircleIcon
                        color="primary"
                        sx={{ fontSize: "20px" }}
                      />
                      <ListItemText className="mx-2" primary={res.res} />
                    </ListItem>
                  ))}
                </List>
              </Col>
              <Col md={5} xs={12}>
                <Typography
                  className="pb-2"
                  fontWeight={500}
                  variant="h6"
                  component="div"
                >
                  Requirements
                </Typography>

                <List>
                  {Requirements.map((req, idx) => (
                    <ListItem key={idx} className="p-0">
                      <CheckCircleIcon
                        color="primary"
                        sx={{ fontSize: "20px" }}
                      />
                      <ListItemText className="mx-2" primary={req.req} />
                    </ListItem>
                  ))}
                </List>

                <Typography
                  className="pt-3"
                  fontWeight={500}
                  variant="h6"
                  component="div"
                >
                  Benefits
                </Typography>

                <List>
                  <ListItem className="p-0">
                    <CheckCircleIcon
                      color="primary"
                      sx={{ fontSize: "20px" }}
                    />
                    <ListItemText
                      className="mx-2"
                      primary="Yearly salary review"
                    />
                  </ListItem>
                </List>
              </Col>
            </Row>
            <Row className="py-3">
              <Typography
                className="pb-2"
                fontWeight={500}
                variant="h6"
                component="div"
              >
                Working days
              </Typography>

              <Typography gutterBottom variant="subtitle1" component="div">
                Weekly: 5 days <br />
                Weekend: Friday, Saturday
              </Typography>
            </Row>
          </div>
        </Collapse>

        {!open && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => setOpen(!open)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            className="text-primary py-4 fw-bold"
          >
            Show more
          </span>
        )}
      </div>
    </Container>
  );
};

export default Career;

const Responsibilities = [
  {
    res: "Frontend and Backend Architecture Integration, Development, and Deployment.",
  },
  {
    res: "Experience in frontend technologies like React Js, Next Js etc.",
  },
  {
    res: "Good knowledge in Python, Django, GraphQL, Django and Rest Framework.",
  },
  {
    res: "Experience with serverless architecture (Nginx, Apache, Cache server, load balancer, etc).",
  },
  {
    res: "Database Design and Development (PostgreSQL, MySQL, MongoDB, etc).",
  },
  {
    res: "Git version control, GitLab and Bitbucket.",
  },
  {
    res: "Already written code must be understood.",
  },
  {
    res: "AWS, Namecheap, Digital Ocean etc.",
  },
  {
    res: "Must have a Leadership mentality.",
  },
];

const Requirements = [
  {
    req: "Bachelor’s/Master’s degree in Engineering, Computer Science (or equivalent experience).",
  },
  {
    req: "At least 2+ years of relevant experience as a back-end develop.",
  },
  {
    req: "Fluent in verbal and written English.",
  },
];
